export const POLO_SHIRTS_MEN_ESSENTIALS_BRK = [
  {
    title: 'POLO MICROPIQUE P010',
    description: '100% Polyester Micropiqué',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product: '/images/essentials/polo-negro-pique.webp',
  },
  {
    title: 'POLO PERFORMANCE P115',
    description: '100% Polyester Micropiqué',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product: '/images/essentials/polo-brisa.webp',
  },
  {
    title: 'POLO PERFORMANCE PRO P210',
    description: 'Recycled Polyamide 90% Elastane 10%',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product: '/images/essentials/polo-dual-blanco.webp',
  },
  {
    title: 'POLO PERFORMANCE JASPEADO P410',
    description: 'Polyester 60% Polyamide 29% Elastane 11%',
    price: '35€',
    colors: ['#ffffff', '#beddef', '#f5dbeb', '#212e43', '#191819'],
    image_product: '/images/essentials/polo-azul-jaspeado.webp',
  },
];

export const MIDLAYERS_MEN_ESSENTIALS_BRK = [
  {
    title: 'MID LAYER PERFORMANCE PRO M210',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#babebb', '#2a333d'],
    image_product: '/images/essentials/mid-layer-marino.webp',
  },
  {
    title: 'MID LAYER PERFORMANCE PRO M215',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#babebb', '#2a333d'],
    image_product: '/images/essentials/mid-layer-gris-bicolor.webp',
  },
  {
    title: 'MID LAYER PERFORMANCE PRO M225',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#babebb', '#2a333d'],
    image_product: '/images/essentials/chaqueta-esencial.webp',
  },
];

export const VEST_MEN_ESSENTIALS_BRK = [
  {
    title: 'CHALECO PERFORMANCE PRO V210',
    description: 'Recycled Polyamide 91% Elastane 9%',
    price: '35€',
    colors: ['#ffffff', '#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/chaleco-negro-2.webp',
  },
  {
    title: 'CHALECO PERFORMANCE PRO V320',
    description: '97% Polyester 3% Elastane',
    price: '35€',
    colors: ['#ffffff', '#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/VEST-GRIS.jpg',
  },
  {
    title: 'CORTAVIENTOS PERFORMANCE PRO W310',
    description: 'Polyester 97% Elastane 3%',
    price: '35€',
    colors: ['#babebb', '#212e43', '#191819'],
    image_product: '/images/essentials/WINDSTOPPER_MEN.webp',
  },
];
